import { RowViewLink } from '@/components/common/RowActions';
import type { PromoAdjustmentUnit, PromoDrillParams, PromoMember } from '../types/promotion.types';

const VIEW_INSTITUTES_LABEL = 'View Institutes';

interface PromoZmInstitutesLinkProps {
  unit: PromoAdjustmentUnit;
  promoItemId: number;
  zm: PromoMember;
  zmSearch: PromoDrillParams;
}

export function PromoZmInstitutesLink({
  unit,
  promoItemId,
  zm,
  zmSearch,
}: PromoZmInstitutesLinkProps) {
  const params = { promoItemId, zmId: zm.userId };
  const ariaLabel = `Institutes where ${zm.name} handed it out`;

  if (unit === 'marketPromotion') {
    return (
      <RowViewLink
        to="/market-promotion/adjustment/$promoItemId/$zmId"
        params={params}
        search={zmSearch}
        label={VIEW_INSTITUTES_LABEL}
        aria-label={ariaLabel}
      />
    );
  }
  return (
    <RowViewLink
      to="/promotion/adjustment/$promoItemId/$zmId"
      params={params}
      search={zmSearch}
      label={VIEW_INSTITUTES_LABEL}
      aria-label={ariaLabel}
    />
  );
}
